// extracted by mini-css-extract-plugin
module.exports = {"wpPreview":"wpPreview--1FT1J","wpPreview_box":"wpPreview_box--3lGT6","wpPreview_img":"wpPreview_img--25UEi","wpPreview_opt":"wpPreview_opt--24QVB"};